import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import React, { useEffect, useRef, useState } from "react";
import Container from "react-bootstrap/Container";
import Tooltip from "@mui/material/Tooltip";
import { TASKS_SCHEDULE_URL, TASKS_SCHEDULE_SEARCH_URL, REPORT_USER_URL } from "../../Constants/Constants";
import AddTaskIcon from "@mui/icons-material/AddTask";
import AxiosInstance from "../../services/AxiosInstance";
import { useAlert } from "../alerts/AlertContext";

import AppTableView from "../AppTableView";
import Grid from "@mui/material/Grid2";
import { IconButton } from "@mui/material";
import { TASK_SCHEDULE_COLUMNS } from "./grid/GridDataConstants";
import { USER_ID } from "../../Constants/StorageConstants";
import TaskSchedulerDialog from "./TaskSchedulerDialog";
import { isEmpty } from "../../Constants/RolesConstants";

function TaskScheduler({ componentPermissions }) {
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
      [`&.${tableCellClasses.head}`]: {
        //backgroundColor: theme.palette.common.blue,
        backgroundColor: "#1976d2",
        color: theme.palette.common.white,
        paddingTop: 2,
        paddingBottom: 2,
      },
      [`&.${tableCellClasses.body}`]: {
        fontSize: 12,
        paddingTop: 2,
        paddingBottom: 2,
      },
    }));
  
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
      // hide last border
      "&:last-child td, &:last-child th": {
        border: 0,
      },
    }));

    const [loading, setLoading] = useState(false);
    const [taskSchedules, setTaskSchedules] = useState([]);

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const [totalElements, setTotalElements] = useState(0);

    useEffect(() => {
       fetchTaskSchdules();
    }, [page, rowsPerPage]);

    const fetchTaskSchdules = () => {
        setLoading(true);
        AxiosInstance.post(TASKS_SCHEDULE_SEARCH_URL, {
          page: page,
          size: rowsPerPage,
          direction: "desc",
          sort: "createdOn",
          search: "",
          userId: localStorage.getItem(USER_ID)
        })
          .then((response) => {
            setTaskSchedules(response.data.content);
            setTotalElements(response.data.totalElements);
            setLoading(false);
          })
          .catch((err) => console.error(err));
      };

    const handleClickOpen = () => {
        //setOpen(true);
        //initializeSysValues();
    };
      
    return (
        <Container fluid>
            <Box
                sx={{
                padding: 2,
                paddingTop: 0,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                gap: 1,
                }}
            >
               <TaskSchedulerDialog scheduleId={0} selectedScheduleName={""} fetchTaskSchdules={fetchTaskSchdules} componentPermissions={componentPermissions} actionType="Add"/>
            </Box>

            <Box sx={{ width: "100%" }}>
                <Paper sx={{ width: "100%", mb: 2 }}>
                {loading ? (
                    <Box display="flex" justifyContent="center" mt={4}>
                    <CircularProgress />
                    </Box>
                ) : (
                    <Grid gap={2} container spacing={2} columns={12}>
                        <Grid size={{ xs: 12, lg: 12 }}>
                            <AppTableView
                                rows={taskSchedules}                            
                                cols={TASK_SCHEDULE_COLUMNS({
                                fetchTaskSchdules,
                                componentPermissions,
                                actionType:
                                    isEmpty(componentPermissions) ||
                                    componentPermissions?.["canUpdate"]
                                    ? "Edit"
                                    : "",
                                })}
                            />
                        </Grid>
                    </Grid>
                )}
                </Paper>
            </Box>
        </Container>
    )


}
export default TaskScheduler;